const initialState = {
  headerButton: null,
};

export const headerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_HEADER_BUTTON':
      return { ...state, headerButton: action.payload };
    default:
      return state;
  }
};
